module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAATlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////+QlxstAAAAGXRSTlMA57OJSffieD0O7tXBk1wzJSAZ2smrgGNVft1W/wAAALtJREFUKM/VzlkSgyAURNF+CAjOmkTt/W80BkscYAO5Hwx1KACxfm5exryauceztWasXm80vknb6sH7QbeWfI+n6Yp2QWyxrPSxcYbK45JXNA6hoWKLRy2rISwafpD0YYOtjuJT9MJum+owJnWsgZ6CbMIeBYusBVDUedRUsBzzONKCISluNwpDG+4VFyMj7g/IibJ/I+IxHeu/ROGUx4kCxTKPJRUcTTmlOJWG7ncidMXQfqNTkqIoB3wBNVsUJYuGXQcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/faq.png
// module id = 91
// module chunks = 1